export { NextRouteComponent as default } from '@pankod/refine-nextjs-router'
import { checkAuthentication } from '@pankod/refine-nextjs-router'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'

import { authProvider } from 'src/authProvider'
import dataProvider from 'src/dataProvider'

import type { GetServerSideProps } from 'next'

const API_URL = process.env.API_URL

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { isAuthenticated, ...props } = await checkAuthentication(
    authProvider,
    context
  )

  if (!isAuthenticated) {
    return props
  }

  const translateProps = await serverSideTranslations(context.locale ?? 'en', [
    'common',
  ])

  const { query } = context

  try {
    const data = await dataProvider(API_URL).getList({
      resource: query['resource'] as string,
    })

    return {
      props: {
        ...translateProps,
        initialData: data,
      },
    }
  } catch (error) {
    return {
      props: { ...translateProps, initialData: [] },
    }
  }
}
